import { site, nav, legalNav, brands, social, apps } from '../content.js'
import Logo from '../components/Logo.jsx'

// Brand marks aren't in Icon.jsx (it only holds line icons), so they live here.
const marks = {
  instagram: <path d="M12 2.2c3.2 0 3.6 0 4.8.1 3.3.1 4.8 1.7 4.9 4.9.1 1.3.1 1.6.1 4.8s0 3.6-.1 4.8c-.1 3.2-1.7 4.8-4.9 4.9-1.3.1-1.6.1-4.8.1s-3.6 0-4.8-.1c-3.3-.1-4.8-1.7-4.9-4.9C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.8C2.4 3.9 3.9 2.4 7.2 2.3 8.4 2.2 8.8 2.2 12 2.2zm0 4.8a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 8.2a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4zm5.2-9.6a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4z" />,
  facebook: <path d="M24 12a12 12 0 1 0-13.9 11.9v-8.4H7.1V12h3V9.4c0-3 1.8-4.7 4.5-4.7 1.3 0 2.7.2 2.7.2v3h-1.5c-1.5 0-2 .9-2 1.9V12h3.4l-.5 3.5h-2.9v8.4A12 12 0 0 0 24 12z" />,
  apple: <path d="M16.4 12.6c0-2.6 2.1-3.8 2.2-3.9-1.2-1.8-3.1-2-3.7-2-1.6-.2-3.1.9-3.9.9-.8 0-2-.9-3.3-.9-1.7 0-3.3 1-4.2 2.5-1.8 3.1-.5 7.7 1.3 10.2.9 1.2 1.9 2.6 3.2 2.6 1.3-.1 1.8-.8 3.3-.8s2 .8 3.3.8c1.4 0 2.3-1.3 3.1-2.5 1-1.4 1.4-2.8 1.4-2.9 0 0-2.7-1-2.7-4zM13.9 5c.7-.9 1.2-2 1-3.2-1 0-2.2.7-3 1.5-.6.7-1.2 1.9-1 3.1 1.1.1 2.3-.6 3-1.4z" />,
  android: <path d="M17.5 9.2 19.3 6a.4.4 0 0 0-.7-.4l-1.8 3.2A11 11 0 0 0 12 7.8c-1.7 0-3.3.4-4.8 1L5.4 5.6a.4.4 0 1 0-.7.4l1.8 3.2A10.2 10.2 0 0 0 1 17.5h22a10.2 10.2 0 0 0-5.5-8.3zM7 14.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm10 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />,
}
const Mark = ({ name, size = 18 }) => <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">{marks[name]}</svg>
const ext = { target: '_blank', rel: 'noopener noreferrer' }

export default function Footer({ linkBase = '' }) {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <Logo linkBase={linkBase} />
          <div className="footer-social">
            {social.map((s) => <a key={s.href} href={s.href} {...ext} aria-label={`${site.product} on ${s.label}`}><Mark name={s.icon} /></a>)}
          </div>
          <div className="footer-apps">
            {apps.map((a) => (
              <a key={a.href} href={a.href} {...ext} aria-label={`${site.product} for ${a.label} on ${a.store}`}>
                <Mark name={a.icon} size={20} /><span><small>{site.product} for {a.label}</small>{a.store}</span>
              </a>
            ))}
          </div>
        </div>
        <div className="footer-links">
          <nav>{nav.map((n) => <a key={n.href} href={n.href.startsWith('#') ? linkBase + n.href : n.href}>{n.label}</a>)}</nav>
          <nav className="footer-brands" aria-label="Our products">
            {brands.map((b) => <a key={b.href} href={b.href} {...ext}>{b.label}</a>)}
          </nav>
        </div>
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} {site.name}. Powered by {site.product}.</p>
          <nav className="footer-legal" aria-label="Legal">
            {legalNav.map((n) => <a key={n.href} href={n.href}>{n.label}</a>)}
          </nav>
        </div>
      </div>
    </footer>
  )
}
